export default __webpack_public_path__ + "static/media/NotoSansKR-Black.19b75461.woff";